import { INSTRUCTIONS_BASE_URL } from 'src/common/consts/ApiUrlPaths';
import { Logger } from 'src/common/services/Logger';

import { DeleteProduct } from './DeleteRunService';
import type { IInstructionStatusResponse } from './InstructionService.types';
import { apiCall } from './ServerApi';

export type { IInstructionStatusResponse } from './InstructionService.types';

export const getInstructionStatus = async (
	product: DeleteProduct,
	instructionId: string
): Promise<IInstructionStatusResponse> => {
	try {
		return await apiCall('GET', `${INSTRUCTIONS_BASE_URL}/${product}/${instructionId}`, {
			isAbsoluteUrl: true
		});
	} catch (e) {
		Logger.error('getInstructionStatus failed', { product, instructionId, e });
		throw e;
	}
};
